import Icon from "@ant-design/icons";
import {Button, Form, message} from "antd";
import React, {useEffect, useState} from "react";
import {
    apiSendEmailTemplate
} from "../../actions/storyboardApi";
import {
    addVizListener,
    getCurrentViz,
    TableauEventListener
} from "../../components/Tableau/TableauViz";
import {Workbook} from "../../types/Storyboard";
import {ReactComponent as EmailSvg} from './email.svg';
import styles from "./styles.module.scss";
import {UserDetails} from "../../actions/api";
import GenericSendEmailAttachmentModel from "./GenericSendEmailAttachmentModel";
import NovoEmailAttachmentModel from "./NovoEmailAttachmentModel";

const EmailIcon = (props: any) => <Icon component={EmailSvg} {...props} />

export type GenerateEmailButtonProps = {
    userDetails?: UserDetails
    workbook?: Workbook
}

export const ActionButton = ({buttonLabel, disabled, handleAction}:
                          { buttonLabel: string, disabled?: boolean, handleAction: () => void }) => (
    <Button type='primary' className={styles.generateEmailButton}
            onClick={() => handleAction()}
            disabled={disabled}
            icon={<EmailIcon className={styles.generateEmailIcon}/>}
    >
        {buttonLabel}
    </Button>
)

export const GenerateEmailButton = ({userDetails, workbook}: GenerateEmailButtonProps) => {
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [form] = Form.useForm()
    const [vizAvailable, setVizAvailable] = useState(false)
    const hideButton = workbook === undefined || !workbook.tags.map(i => i.toUpperCase()).includes("EXPORT")
    const [isDisabled, setDisabled] = useState(true);

    let userEmail: string
    if (userDetails) {
        userEmail = userDetails.username
    }

    const handleSendEmailTemplate = async (storyboard: string): Promise<boolean> => {
        try {
            const response = await apiSendEmailTemplate(storyboard, userEmail)
            if (response) {
                message.success(`Email successfully sent to ${userEmail}`)
                return response
            } else {
                message.error(`Failed to send email to ${userEmail}`)
            }
        } catch (e) {
            console.error(e)
            return false
        } finally {
            setIsModalVisible(false)
            form.resetFields()
        }
        return false
    }

    const showModal = () => {
        setIsModalVisible(true)
    }

    useEffect(() => {
        let intervalId : NodeJS.Timeout;
        if (!vizAvailable) {
            intervalId = setInterval(() => {
                const viz = getCurrentViz();
                if (viz == null) {
                    return
                }
                try {
                    viz.getWorkbook()
                } catch (e) {
                    return
                }
                if (viz.getWorkbook() == null) {
                    return;
                }
                setVizAvailable(true)
                clearInterval(intervalId)
            }, 500);
        }
        return () => {
            if (intervalId != null) {
                clearInterval(intervalId)
            }
        }
    }, [vizAvailable])


    useEffect(() => {
        if (!hideButton) {
            const listener: TableauEventListener = {
                onEvent: function (): void {
                    setDisabled(getCurrentViz()!.getWorkbook().getActiveSheet().getIndex() !== 1)
                }
            }
            addVizListener(listener)
        }
    }, [hideButton])


    if (hideButton) {
        return null;
    }

    if (workbook?.tags.includes("novo-diabetes-insights")) {
        return <>
            <ActionButton buttonLabel='Generate Email' handleAction={showModal} disabled={isDisabled}/>
            <NovoEmailAttachmentModel
                workbook={workbook}
                isModalVisible={isModalVisible}
                setIsModalVisible={(visible) => setIsModalVisible(visible)}
            />
        </>
    } else if (workbook?.tags.includes("peristeen-plus-bim")) {
        return <ActionButton buttonLabel='Send Email Template' handleAction={() => handleSendEmailTemplate('COLOPLAST.BIM')} disabled={false} />
    } else if (workbook?.tags.includes("pfizer-migraine")) {
        return <ActionButton buttonLabel='Send Email Template' handleAction={() => handleSendEmailTemplate('PFIZER.MIGRAINE')} disabled={false} />
    } else if (workbook?.tags.includes("bi-therapy-area")) {
        return <ActionButton buttonLabel='Send Email Template' handleAction={() => handleSendEmailTemplate('BI.THERAPY.AREA')} disabled={false} />
    } else if (workbook?.tags.includes("email-export")) {
        const viz = getCurrentViz();
        return <>
            <ActionButton buttonLabel="Send as Email Attachment"
                          handleAction={() => setIsModalVisible(true)}
                          disabled={!vizAvailable}
            ></ActionButton>
            {viz?.getWorkbook()?.getName() && <GenericSendEmailAttachmentModel viz={viz} isOpen={isModalVisible} onCancel={() => {setIsModalVisible(false)}}/>}

        </>
    } else {
        return <></>
    }
}
